/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import generator from 'generate-password'
// axios
import axios from 'axios'
// Theme Configurations
import '../themeConfig.js'
// Firebase
import '@/firebase/firebaseConfig'
// Auth0 Plugin
//import AuthPlugin from "./plugins/auth";
// ACL
import acl from './acl/acl'
// Globally Registered Components
import './globalComponents.js'
// Styles: SCSS
import './assets/scss/main.scss'
// Tailwind
import '@/assets/css/main.css';
// Vue Router
import router from './router'
// Vuex Store
import store from './store/store'
// i18n
import i18n from './i18n/i18n'
// Vuesax Admin Filters
import './filters/filters'
// Clipboard
import VueClipboard from 'vue-clipboard2'
// Tour
import VueTour from 'vue-tour'
// VeeValidate
import VeeValidate from 'vee-validate';
// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ButtonComponent from "./components/Buttons/ButtonComponent";
import GroupComponent from './components/Buttons/GroupComponent'
import bus from './bus.js'
import JsonExcel from 'vue-json-excel'

window.bus = bus;
Vue.use(Vuesax);
Vue.use(axios);
Vue.component('ButtonComponent', ButtonComponent);
Vue.component('GroupComponent', GroupComponent);
Vue.use(generator);
Vue.prototype.$http = axios;
window.axios = axios;

Vue.component('downloadExcel', JsonExcel);

//Vue.use(AuthPlugin);

import VuejsDialog from 'vuejs-dialog'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(VueClipboard);


Vue.use(VueTour);
require('vue-tour/dist/vue-tour.css');

import en from 'vee-validate/dist/locale/en.js';
import ru from 'vee-validate/dist/locale/ru.js';
import az from 'vee-validate/dist/locale/az.js';
Vue.use(VeeValidate, {
    i18n,
    dictionary: {
        ru: ru,
        en: en,
        az: az,
    }
});

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'YOUR_API_KEY',
    libraries: 'places', // This is required if you use the Auto complete plug-in
  },
});

Vue.use(VueHammer);


// Feather font icon
require('./assets/css/iconfont.css');


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
if (window.location.hostname === 'esd.kongulov.dev'){
    window.apiUrl = 'https://esd.kongulov.dev/api';
}
else if (window.location.hostname === 'esd.techprodc.com'){
    window.apiUrl = 'https://esd.techprodc.com/api';
}
else window.apiUrl = 'http://esd-back.test/api';

if (localStorage.getItem('lang')){
    window.lang = localStorage.getItem('lang');
}
else{
    localStorage.setItem('lang', 'en');
    window.lang = 'en';
}

if (localStorage.getItem('itemsPerPage')){
    window.itemsPerPage = localStorage.getItem('itemsPerPage');
}else{
    localStorage.setItem('itemsPerPage', 10);
    window.itemsPerPage = 10;
}

window.userInfo = {
    name : 'Loading...',
    limit : 'Loading...',
};
window.token = false;
window.logout = function() {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('userRole');

    window.userInfo = false;
    window.token = false;
    window.location = '/pages/login';
};

if (localStorage.getItem('loggedIn')){
    window.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    window.token = localStorage.getItem('token');
    window.lang = window.userInfo.lang;
}
//let thisInst = this;
window.updateMyProfile = function(){
    axios.get(apiUrl+'/auth/user?token='+window.token)
        .then(function (response) {
            let data = response.data;
            if(data.code === 200){
                let user = data.data;
                localStorage.setItem('userInfo', JSON.stringify(user));
                for(let index in user) {
                    if (user.hasOwnProperty(index)) {
                        window.userInfo[index] = user[index];
                    }
                }
            }
            else if (data.code === 401){
                window.logout();
            }
        });
};

if (window.token){
    window.updateMyProfile();
    setInterval(function () {
        window.updateMyProfile();
    }, 60000);

    let refreshToken = false;
    setInterval(function () {
        let currentTimestamp = Math.floor(Date.now() / 1000);
        var expiredTimestamp = Date.parse(window.userInfo.token_expired) / 1000;

        if (currentTimestamp > expiredTimestamp - (20 * 60)){
            if (!refreshToken){
                refreshToken = true;
                axios.get(apiUrl+'/auth/refresh?token='+window.token)
                    .then(function (response) {
                        let data = response.data;
                        if(data.code === 200){
                            window.token = data.data.token;
                            localStorage.setItem('token', data.data.token);
                        }
                        refreshToken = false;
                    });

            }
        }

    }, 60000);
}

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
